
import { Component, Mixins, Prop } from "vue-property-decorator";
import { SelectorDialogMixin } from "../../../system/dialogs/mixins";

@Component({
})
export default class ProjectTeamSelectableDialogMixin extends Mixins(SelectorDialogMixin) {
  @Prop({ default: "プロジェクトチーム" })
  name: string;

  get title(): string {
    return this.name + "選択";
  }
}
